import React, {memo, Suspense, useMemo, useState} from "react"
import {TemplatedSearchBanner} from "../searchBanner/templatedSearchBanner"
import {SearchBannerContext} from "../searchBanner/utils"
import connect from "./connect"

const MemoTemplatedSearchBanner = memo(TemplatedSearchBanner)

export const SearchBannerProvider = memo(
    ({
        json,
        siteUrl,
        hasPreviousPage,
        hasStructuredBrowsing,
        urlIsSaleOrClearance,
        paddingTop,
        children,
    }: {
        json: any
        siteUrl: string
        hasPreviousPage: boolean
        hasStructuredBrowsing: boolean
        urlIsSaleOrClearance: boolean
        paddingTop?: number
        children?: any
    }) => {
        const [isExpanded, setIsExpanded] = useState<boolean>(false)
        const [hasChevron, setHasChevron] = useState<boolean>(!!json || !!json?.containers?.[0])
        const toggleIsExpanded = () => setIsExpanded(!isExpanded)
        const handleShowChevron = (show: boolean) => setHasChevron(show)

        const contextValue = useMemo(
            () => ({
                isExpanded,
                toggleIsExpanded,
                hasChevron,
                handleShowChevron,
                siteUrl,
            }),
            [isExpanded, toggleIsExpanded, hasChevron, siteUrl],
        )

        return (
            <Suspense>
                <SearchBannerContext.Provider value={contextValue}>
                    {children}
                    <MemoTemplatedSearchBanner
                        key="only-ever-one"
                        paddingTop={paddingTop}
                        json={json}
                        hasPreviousPage={hasPreviousPage}
                        hasStructuredBrowsing={hasStructuredBrowsing}
                        urlIsSaleOrClearance={urlIsSaleOrClearance}
                    />
                </SearchBannerContext.Provider>
            </Suspense>
        )
    },
)

SearchBannerProvider.displayName = "SearchBannerProvider"

export default connect(SearchBannerProvider)
